
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { HeaderComponent } from './layout/header/header.component';
import { FullComponent } from './layout/full/full.component';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { ScadTestFlowHeadComponent } from './scad-widget/organism/scad-test-flow-head/scad-test-flow-head.component';
import { ScadDragDropBodyComponent } from './scad-widget/organism/scad-drag-drop-body/scad-drag-drop-body.component';
import { ScadReadTabAreaComponent } from './scad-widget/organism/scad-read-tab-area/scad-read-tab-area.component';
import { ScadRightSidebarComponent } from './scad-widget/organism/scad-right-sidebar/scad-right-sidebar.component';
import { ConfirmAlertComponent } from './scad-widget/alerts/confirm-alert/confirm-alert.component';
import { LineChartComponent } from './charts/line-chart/line-chart.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { SearchFilterPipePipe } from '../core/pipes/search-filter-pipe.pipe';
import { CircleLoaderComponent } from './scad-widget/loader/circle-loader/circle-loader.component';
import { LinearLoaderComponent } from './scad-widget/loader/linear-loader/linear-loader.component';
import { LineChartHtmlComponent } from './charts/line-chart-html/line-chart-html.component';
import { ScenarioChartComponent } from './charts/scenario-chart/scenario-chart.component';

@NgModule({
  declarations: [
    SidebarComponent,
    HeaderComponent,
    FullComponent,
    ScadTestFlowHeadComponent,
    ScadDragDropBodyComponent,
    ScadReadTabAreaComponent,
    ScadRightSidebarComponent,
    ConfirmAlertComponent,
    LineChartComponent,
    SearchFilterPipePipe,
    CircleLoaderComponent,
    LinearLoaderComponent,
    LineChartHtmlComponent,
    ScenarioChartComponent,
    
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatMenuModule,
    MatButtonModule,
    MatDialogModule,
    NgSelectModule,
    FormsModule,
    NgApexchartsModule,
  ],
  exports:[
    ScadTestFlowHeadComponent,
    ScadDragDropBodyComponent,
    ScadReadTabAreaComponent,
    LineChartComponent,
    SearchFilterPipePipe,
    CircleLoaderComponent,
    LinearLoaderComponent,
    LineChartHtmlComponent,
    ScenarioChartComponent
  ]

})
export class SharedModule { }
